import React, { useContext } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Context } from './../../../Store'
import { CheckInDate } from './CheckInDate'
import { RentRentention } from './RentRetention'
import { CheckOutDate } from './CheckOutDate'
import { HowManyPeople } from './HowManyPeople'
import { Age } from './Age'
import { Gender } from './Gender'
import { Profession } from './Profession'
import { AboutYourself } from './AboutYourself'
import { Payment } from './Payment'
import { PhoneNumber } from './PhoneNumber'
import { TermsAndConditionsBlock } from '../TermsAndConditionsBlock'
import { isMobile } from 'react-device-detect'
import { BackButton } from './BackButton'
import { NextButton } from './NextButton'
import { TenantProposalField } from './TenantProposalField'
import { BookingContext } from '../../../utils/BookingContext'
import { Nationality } from './Nationality'
import PricingDetailCard from '../PricingDetailCard'
import { EasyPayPlanCard } from '../EasyPayPlanCard'

export const GroupStepsSection = () => {
  const [{ current_step, property }] = useContext(Context)
  const { hasCounteroffer } = useContext(BookingContext)
  const { t } = useTranslation()
  const styleClasses = useStyles()

  return (
    <section className={styleClasses.formGreySection}>
      {current_step === 1 && (
        <>
          <Typography variant="h4">{t('booking.title')}</Typography>
          <CheckInDate />
          <RentRentention />
          <CheckOutDate />
          <HowManyPeople />
        </>
      )}
      {current_step === 2 && (
        <>
          <Typography variant="h4">{t('booking.title')}</Typography>
          <Age />
          <Gender />
          <Profession />
          <Nationality />
          <PhoneNumber />
          <AboutYourself />
        </>
      )}
      {current_step === 3 && (
        <>
          <Typography variant="h4">{t('booking.title')}</Typography>
          {!isMobile && <PricingDetailCard forStepThree />}
          <EasyPayPlanCard />
        </>
      )}
      {current_step === 4 && (
        <>
          <Grid item lg={11}>
            <Grid item style={{ margin: '0.5rem 0 0.5rem 0' }}>
              <Typography variant="h4">{t('booking.paymentInfo.title')}</Typography>
            </Grid>
            <Grid item lg={11}>
              <Typography variant="subtitle1">{t('booking.paymentInfo.adviceCost.title')}</Typography>
            </Grid>
            {property.ownerIsPropertyManager || hasCounteroffer ? (
              <Grid itemlg={11}>
                <Typography variant="subtitle2">{t('booking.paymentInfo.adviceCost.subtitleOwnerIsPropertyManager')}</Typography>
              </Grid>
            ) : (
              <Grid item lg={11}>
                <Typography variant="subtitle2">{t('booking.paymentInfo.adviceCost.subtitle')}</Typography>
              </Grid>
            )}
            <Grid item container spacing={2} wrap="nowrap" lg={12} style={{ margin: '0.5rem 0 0.5rem 0' }}>
              <TenantProposalField />
            </Grid>
          </Grid>
          <Payment />
          {!isMobile && <TermsAndConditionsBlock />}
        </>
      )}
      {!isMobile && (
        <Grid container lg={11} style={{ paddingBottom: '2rem' }} className="justify-between">
          <Grid item>
            <BackButton />
          </Grid>
          <Grid item>
            <NextButton />
          </Grid>
        </Grid>
      )}
    </section>
  )
}

const useStyles = makeStyles((theme) => ({
  formGreySection: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      padding: '4rem 4rem 0 4rem',
    },
  },
}))
